/* eslint-disable @typescript-eslint/naming-convention */
export enum AnalyticsView {
  ACCOUNT_VIEW = 'account_view',
  BADGES = 'badges',
  CART_VIEW = 'cart_view',
  CHECKOUT_VIEW = 'checkout_view',
  CONFIRMATION = 'confirmation',
  FOOD_AND_DRINK = 'food_and_drink',
  GIFT_CARD_PURCHASE = 'gift_card_purchase',
  GIFT_CARDS_VIEW = 'gift_cards_view',
  HOME_PAGE = 'home_page',
  LOYALTY = 'loyalty',
  MDP_VIEW = 'mdp_view',
  MOVIE_LIST_VIEW = 'movie_list_view',
  PAGE_VIEW = 'page_view',
  REFUND_START = 'refund_start',
  SEARCH = 'search',
  SEAT_MAP = 'seat_map',
  SIAT_VIEW = 'siat_view',
  THEATER_VIEW = 'theatre_view',
}

export enum AnalyticsEvent {
  CART_ADD = 'cart_add',
  CART_REMOVE = 'cart_remove',
  CHANGE_SEAT = 'change_seat',
  DATA_LAYER = 'data_layer',
  EMAIL_SIGNUP = 'email_signup',
  ERROR = 'error',
  ERROR_PRESENTED = 'error_presented',
  FAVORITE_THEATER_ADD = 'favorite_theater_add',
  FAVORITE_THEATER_REMOVE = 'favorite_theater_remove',
  LINK_CLICK = 'link_click',
  MC_CANCEL = 'mc_cancel',
  MC_SAVINGS_CALC_OPEN = 'mc_savings_calc_open',
  MC_SAVINGS_CALC_SUBMIT = 'mc_savings_calc_submit',
  PRIVATE_EVENT_SUBMIT = 'private_event_submit',
  PRODUCT_QUICKVIEW = 'product_quickview',
  PURCHASE = 'purchase',
  QUICK_REORDER = 'quick_reorder',
  SELECT_SHOWTIME = 'select_showtime',
  SHOWTIME_VIEW_MODE_CHANGE = 'showtime_view_mode_change',
  SIAT_UPSELL = 'siat_upsell',
  SMS_CHECKBOX_PRESENTED = 'sms_checkbox_presented',
  SORT_FILTER_SELECT = 'sort_filter_select',
  USER_LOGIN = 'user_login',
  USER_LOGOUT = 'user_logout',
  USER_REGISTER = 'user_register',
  USER_UPDATE = 'user_update',
  USER_UPDATE_SHIPPING_INFO = 'user_update_shipping_info',
  VIDEO_COMPLETE = 'video_complete',
  VIDEO_PROGRESS = 'video_progress',
  VIDEO_START = 'video_start',
  WATCH_LIST_ADD = 'watch_list_add',
  WATCH_LIST_REMOVE = 'watch_list_remove',
}

export enum AnalyticsLinkAction {
  CLICK = 'Click',
}

export enum AnalyticsPageCategories {
  CAROUSEL_FEATURED_MOVIES = 'Carousel|Featured Movies',
  CAROUSEL_SHOWDATE = 'Carousel|Showdate',
  CART = 'Cart',
  CONTACT_US = 'Contact Us',
  CONTENT_ADS = 'content ads',
  CONTENT_PAGE = 'Content Page',
  FOOTER = 'Footer Nav',
  GENRE = 'Genre',
  MAIN_NAV = 'Main Nav',
  MOVIE_REWARDS = 'Movie Rewards',
  MOVIES_PAGE = 'Movies Page',
  PROFILE = 'Account Profile',
  PURCHASE_HISTORY = 'Purchase History',
  SECONDARY_NAV = 'Secondary Nav',
  THEATER = 'Theatre',
  THEATER_INFO = 'Theatre Info',
  THEATERS = 'Theatres',
  MOVIE_DETAIL = 'MDP',
  WATCH_LIST = 'Watch List',
  POLICY_PAGE = 'Policy Page',
  SEAT_MAP = 'Seatmap',
  SHOWTIME_BLOCK = 'Showtime Block',
}
